export const SESSION_EXPIRED_EVENT = 'cstore:session-expired'

export function emitSessionExpired() {
  if (globalThis.window === undefined) return
  globalThis.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT))
  // Other tabs should also drop the dead session
  void import('@/libs/auth-cross-tab').then(({ broadcastLogout }) => {
    broadcastLogout()
  })
}
